var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('img',{staticClass:"loading_img",attrs:{"src":require("../assets/imagem/loading.svg")}}),_c('p',{staticClass:"loading_title",domProps:{"innerHTML":_vm._s(_vm.title)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }